<template src="./Steps.html"/>

<style lang="scss" src="./Steps.scss"/>
<script>
import {SfButton} from '@storefront-ui/vue';

export default {
  name: "Steps",
  components: {
    SfButton
  },

  model: {
    prop: "active",
    event: "change",
  },

  props: {
    steps: {
      default: []
    },
    active: {
      type: Number,
      default: 0,
    },
    canGoBack: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    parsedSteps() {
      if (this.steps) {
        return this.steps.map((step, index) => ({
          index,
          name: step.name,
          done: index < this.active,
          disabled: !this.canGoBack && index < this.active,
          current: index === this.active,
        }));
      }
      return [];
    },
    progress() {
      return {
        "--_steps-progress-width": `${100 / this.steps.length}%`,
        "--_steps-progress-active-step": this.active + 1,
      };
    },
  },
  methods: {

    stepClick({index, disabled}) {
      if (!disabled) {
        /**
         * Active step changed event
         *
         * @event 'change'
         * @type {Number}
         */
        this.$emit("change", index);
      }
    },
  },
};
</script>

